export const getTableSort = state => state.tableSort;
export const getFilters = state => state.filters;
export const getFilter = ({ filters }, id) => {
  return filters[id];
};
export const getRestoringState = state => state.restoringState;
